export enum VisitTab {
  OVERVIEW = "overview",
  REPORTS = "reports",
}
